(() => {
  'use strict';
  document.querySelectorAll('[data-merlons-roadmap]').forEach((root) => {
    const form = root.querySelector('.merlons-roadmap__form');
    if (!form) return;
    const storageKey = `merlons-roadmap-plan-${document.documentElement.lang.slice(0, 2)}`;
    const success = root.querySelector('[data-roadmap-success]');
    if (success) {
      root.classList.add('is-complete');
      const reader = root.querySelector('[data-roadmap-reader]');
      const isRoadmapReturn = window.location.hash === `#${reader.id}`;
      if (isRoadmapReturn) document.documentElement.removeAttribute('data-merlons-order-request-return');
      const heading = reader.querySelector('[data-reader-heading]');
      const panels = Array.from(reader.querySelectorAll('[data-reader-panel]'));
      const links = Array.from(reader.querySelectorAll('[data-reader-link]'));
      const showChapter = (index, focus = true) => {
        panels.forEach((panel) => { panel.hidden = Number(panel.dataset.readerPanel) !== index; });
        links.forEach((link) => {
          if (Number(link.dataset.readerLink) === index) link.setAttribute('aria-current', 'step');
          else link.removeAttribute('aria-current');
        });
        const active = panels.find((panel) => Number(panel.dataset.readerPanel) === index);
        heading.textContent = active.dataset.readerTitle;
        if (focus) heading.focus();
      };
      let plan;
      try {
        plan = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (!plan || !Number.isFinite(plan.at) || Date.now() - plan.at > 30 * 60 * 1000) {
          sessionStorage.removeItem(storageKey);
          plan = null;
        }
      } catch (_) { plan = null; }
      let startIndex = 0;
      if (plan) {
        startIndex = { planning: 1, renovating: 3, furnishing: 5 }[plan.stage] || 0;
        const label = root.querySelector('[data-roadmap-start-label]');
        const stageLabel = panels.find((panel) => Number(panel.dataset.readerPanel) === startIndex)?.dataset.readerTitle;
        if (label && stageLabel) label.textContent = `: ${stageLabel}`;
        const list = root.querySelector('[data-roadmap-plan]');
        Object.entries(plan.answers || {}).forEach(([key, value]) => {
          if (typeof value !== 'string' || value.length > 200) return;
          const term = document.createElement('dt');
          const definition = document.createElement('dd');
          term.textContent = key;
          definition.textContent = value;
          list.append(term, definition);
        });
      }
      reader.hidden = true;
      const openReader = () => {
        root.classList.add('is-reading');
        success.hidden = true;
        reader.hidden = false;
        showChapter(startIndex, false);
        heading.focus();
        reader.scrollIntoView({ block: 'start' });
      };
      root.querySelector('[data-roadmap-read]').addEventListener('click', (event) => {
        event.preventDefault();
        openReader();
      });
      links.forEach((link) => link.addEventListener('click', (event) => {
        event.preventDefault();
        showChapter(Number(link.dataset.readerLink));
      }));
      if (isRoadmapReturn) openReader();
      return;
    }
    const steps = Array.from(form.querySelectorAll('[data-roadmap-step]'));
    if (!form || !steps.length || form.querySelector('.merlons-roadmap__error')) return;
    const progress = form.querySelector('[data-roadmap-progress]');
    const first = form.querySelector('[data-roadmap-first]');
    const last = form.querySelector('[data-roadmap-last]');
    const fullName = form.querySelector('[data-roadmap-full-name]');
    const country = form.querySelector('[data-roadmap-country]');
    let countryControl = null;
    const countryFace = form.querySelector('[data-roadmap-country-code]');
    const syncCountryFace = () => {
      const selected = country.selectedOptions[0];
      country.closest('[data-roadmap-country-iso]').dataset.roadmapCountryIso = selected.dataset.iso;
      countryFace.textContent = `+${selected.dataset.code}`;
      countryControl?.sync();
    };
    const national = form.querySelector('[data-roadmap-phone]');
    const international = form.querySelector('[data-roadmap-international]');
    const city = form.querySelector('[data-roadmap-city]');
    const otherCity = form.querySelector('[data-roadmap-other-city]');
    const otherLabel = form.querySelector('[data-roadmap-other-city-label]');
    const picker = form.querySelector('[data-roadmap-city-picker]');
    let current = 1;
    const placeDropdown = (anchor, popup, list, searchable) => {
      const box = anchor.getBoundingClientRect();
      const below = window.innerHeight - box.bottom - 16, above = box.top - 16;
      const opensAbove = below < 220 && above > below;
      popup.classList.toggle('is-above', opensAbove);
      list.style.maxHeight = Math.max(80, Math.min(280, (opensAbove ? above : below) - (searchable ? 72 : 20))) + 'px';
    };
    const syncPhone = () => {
      const raw = national.value.trim();
      let digits = raw.replace(/\D/g, '');
      const explicit = raw.startsWith('+') || raw.startsWith('00');
      if (raw.startsWith('00')) digits = digits.slice(2);
      if (explicit) {
        const selectedCode = country.selectedOptions[0].dataset.code;
        const match = digits.startsWith(selectedCode) ? country.selectedOptions[0] : Array.from(country.options)
          .sort((a, b) => b.dataset.code.length - a.dataset.code.length)
          .find((option) => digits.startsWith(option.dataset.code) && option.dataset.primary === 'true');
        if (match) country.value = match.value;
      }
      const chosen = country.selectedOptions[0];
      syncCountryFace();
      const code = chosen.dataset.code;
      if (explicit && digits.startsWith(code)) digits = digits.slice(code.length);
      else if (chosen.dataset.iso === 'GE' && digits.length === 12 && digits.startsWith(code)) digits = digits.slice(code.length);
      const lengths = chosen.dataset.lengths.split(',').map(Number);
      const prefix = chosen.dataset.prefix;
      if (!lengths.includes(digits.length) && prefix && digits.startsWith(prefix)) digits = digits.slice(prefix.length);
      const valid = /^(?:\+|00)?[\d()\s.\-]+$/.test(raw) && lengths.includes(digits.length) && digits.length + code.length >= 8 && digits.length + code.length <= 15;
      national.setCustomValidity(raw && !valid ? national.dataset.error : '');
      international.value = raw && valid ? `+${code}${digits}` : '';
      return { digits, valid };
    };
    national.addEventListener('input', syncPhone);
    national.addEventListener('blur', () => {
      const result = syncPhone();
      if (result.valid) national.value = result.digits;
    });
    country.addEventListener('change', syncPhone);
    const syncOtherCity = () => {
      const other = city.value === 'other';
      otherLabel.hidden = !other;
      otherCity.required = other;
      if (!other) otherCity.value = '';
    };
    city.addEventListener('change', syncOtherCity);
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'merlons-roadmap__city-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.textContent = picker.dataset.placeholder;
    const popup = document.createElement('div');
    popup.className = 'merlons-roadmap__city-popup';
    popup.hidden = true;
    const search = document.createElement('input');
    search.type = 'search';
    search.autocomplete = 'off';
    search.placeholder = picker.dataset.search;
    search.setAttribute('aria-label', picker.dataset.search);
    search.setAttribute('role', 'combobox');
    search.setAttribute('aria-autocomplete', 'list');
    search.setAttribute('aria-expanded', 'false');
    const results = document.createElement('div');
    results.id = `${city.id}-results`;
    results.className = 'merlons-roadmap__city-results';
    results.setAttribute('role', 'listbox');
    results.setAttribute('aria-label', picker.dataset.placeholder);
    trigger.setAttribute('aria-controls', results.id);
    search.setAttribute('aria-controls', results.id);
    const empty = document.createElement('p');
    empty.textContent = picker.dataset.empty;
    empty.setAttribute('role', 'status');
    empty.hidden = true;
    popup.append(search, results, empty);
    picker.append(trigger, popup);
    city.hidden = true;
    city.required = false;
    picker.querySelector('label').hidden = true;
    const choices = Array.from(city.options).filter((option) => option.value);
    const normalize = (text) => text.normalize('NFKC').toLocaleLowerCase().trim();
    let filtered = [], active = -1;
    const close = () => {
      popup.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      search.setAttribute('aria-expanded', 'false');
      search.removeAttribute('aria-activedescendant');
    };
    const highlight = (index) => {
      active = index;
      Array.from(results.children).forEach((option, i) => { option.setAttribute('aria-selected', String(i === active)); });
      const selected = results.children[active];
      if (selected) {
        search.setAttribute('aria-activedescendant', selected.id);
        selected.scrollIntoView({ block: 'nearest' });
      } else search.removeAttribute('aria-activedescendant');
    };
    const choose = (option) => {
      city.value = option.value;
      trigger.textContent = option.textContent;
      trigger.removeAttribute('aria-invalid');
      syncOtherCity();
      close();
      trigger.focus();
    };
    const filter = () => {
      const query = normalize(search.value);
      filtered = choices.filter((option) => normalize(`${option.textContent} ${option.dataset.search || ''}`).includes(query));
      results.replaceChildren();
      filtered.forEach((option, index) => {
        const item = document.createElement('div');
        item.id = `${results.id}-${index}`;
        item.className = 'merlons-roadmap__city-option';
        item.setAttribute('role', 'option');
        item.textContent = option.textContent;
        item.addEventListener('mousedown', (event) => event.preventDefault());
        item.addEventListener('click', () => choose(option));
        results.append(item);
      });
      empty.hidden = filtered.length > 0;
      highlight(filtered.length ? 0 : -1);
    };
    const open = () => {
      closeCustoms();
      popup.hidden = false;
      placeDropdown(trigger, popup, results, true);
      trigger.setAttribute('aria-expanded', 'true');
      search.setAttribute('aria-expanded', 'true');
      search.value = '';
      filter();
      search.focus();
    };
    trigger.addEventListener('click', () => popup.hidden ? open() : close());
    trigger.addEventListener('keydown', (event) => {
      if (['ArrowDown', 'ArrowUp'].includes(event.key)) { event.preventDefault(); open(); }
    });
    search.addEventListener('input', filter);
    search.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (filtered.length) highlight((active + (event.key === 'ArrowDown' ? 1 : -1) + filtered.length) % filtered.length);
      } else if (event.key === 'Enter') {
        event.preventDefault();
        if (filtered[active]) choose(filtered[active]);
      } else if (event.key === 'Escape') { event.preventDefault(); close(); trigger.focus(); }
    });
    picker.addEventListener('focusout', (event) => { if (!picker.contains(event.relatedTarget)) close(); });
    document.addEventListener('pointerdown', (event) => { if (!picker.contains(event.target)) close(); });
    const closeCity = close;
    const customSelects = [];
    const closeCustoms = () => customSelects.forEach((entry) => entry.close());
    const makeCustomSelect = (select, searchable = false) => {
      if (!select) return null;
      const label = select.closest('label');
      const isCountry = select === country;
      const locale = document.documentElement.lang.slice(0, 2);
      const words = { ka: ['მოძებნეთ ქვეყანა', 'შედეგი ვერ მოიძებნა'], en: ['Search countries', 'No results found'], ru: ['Найти страну', 'Ничего не найдено'] }[locale] || ['Search countries', 'No results found'];
      const labelText = select.getAttribute('aria-label') || Array.from(label.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE).map((node) => node.textContent).join(' ').trim();
      const id = `${form.id}-select-${customSelects.length}`;
      const wrap = document.createElement('div');
      wrap.className = 'merlons-roadmap__select';
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'merlons-roadmap__select-trigger';
      trigger.setAttribute('role', searchable ? 'button' : 'combobox');
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-label', labelText);
      if (select.required) trigger.setAttribute('aria-required', 'true');
      const value = document.createElement('span');
      value.className = 'merlons-roadmap__select-label';
      const arrow = document.createElement('span');
      arrow.className = 'merlons-roadmap__select-arrow';
      arrow.setAttribute('aria-hidden', 'true');
      trigger.append(value, arrow);
      const popup = document.createElement('div');
      popup.className = 'merlons-roadmap__select-popup';
      popup.hidden = true;
      let search;
      if (searchable) {
        search = document.createElement('input');
        search.type = 'search'; search.autocomplete = 'off'; search.placeholder = words[0];
        search.className = 'merlons-roadmap__select-search';
        search.setAttribute('role', 'combobox');
        search.setAttribute('aria-label', words[0]);
        search.setAttribute('aria-autocomplete', 'list');
        search.setAttribute('aria-expanded', 'false');
        popup.append(search);
      }
      const list = document.createElement('div');
      list.id = id;
      list.className = 'merlons-roadmap__select-options';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', labelText);
      trigger.setAttribute('aria-controls', id);
      search?.setAttribute('aria-controls', id);
      const error = document.createElement('p');
      error.id = `${id}-error`; error.className = 'merlons-roadmap__select-error'; error.hidden = true;
      error.setAttribute('role', 'alert');
      popup.append(list); wrap.append(trigger, popup, error); label.append(wrap);
      select.hidden = true; select.tabIndex = -1;
      if (isCountry) label.classList.add('is-custom-country');
      const options = Array.from(select.options).filter((option) => option.value);
      const normalize = (text) => text.normalize('NFKC').toLocaleLowerCase().trim();
      const optionText = (option) => `${option.textContent} ${option.dataset.iso || ''} +${option.dataset.code || ''}`;
      let filtered = [], active = -1, typeBuffer = '', typedAt = 0;
      const flagFor = (option) => {
        const flag = document.createElement('span');
        flag.className = 'merlons-roadmap__country-flag'; flag.dataset.roadmapFlag = option.dataset.iso;
        flag.setAttribute('aria-hidden', 'true');
        return flag;
      };
      const updateValue = () => {
        const option = select.selectedOptions[0];
        value.replaceChildren();
        if (isCountry) {
          value.append(flagFor(option), document.createTextNode(`+${option.dataset.code}`));
          trigger.setAttribute('aria-label', `${labelText}: ${option.textContent}`);
        } else value.textContent = option?.textContent || '';
        if (select.value) {
          error.hidden = true; error.textContent = '';
          trigger.removeAttribute('aria-invalid'); trigger.removeAttribute('aria-describedby');
        }
      };
      const highlight = (index) => {
        active = index;
        const rows = Array.from(list.querySelectorAll('[role="option"]'));
        rows.forEach((row, position) => { row.dataset.active = String(position === active); });
        const row = rows[active], control = search || trigger;
        if (row) { control.setAttribute('aria-activedescendant', row.id); row.scrollIntoView({ block: 'nearest' }); }
        else control.removeAttribute('aria-activedescendant');
      };
      const render = () => {
        const query = normalize(search?.value || '');
        filtered = options.filter((option) => normalize(optionText(option)).includes(query));
        list.replaceChildren();
        filtered.forEach((option, index) => {
          const row = document.createElement('div');
          row.id = `${id}-${index}`; row.className = 'merlons-roadmap__select-option';
          row.setAttribute('role', 'option'); row.setAttribute('aria-selected', String(option.selected));
          if (isCountry) row.append(flagFor(option));
          const name = document.createElement('span'); name.textContent = option.textContent;
          row.append(name);
          row.addEventListener('mousedown', (event) => event.preventDefault());
          row.addEventListener('click', () => choose(option));
          list.append(row);
        });
        if (!filtered.length) {
          const empty = document.createElement('p'); empty.className = 'merlons-roadmap__select-empty'; empty.textContent = words[1]; empty.setAttribute('role', 'status'); list.append(empty);
        }
        const chosen = filtered.findIndex((option) => option.selected);
        highlight(filtered.length ? Math.max(0, chosen) : -1);
      };
      const close = () => {
        popup.hidden = true; trigger.setAttribute('aria-expanded', 'false'); trigger.removeAttribute('aria-activedescendant');
        search?.setAttribute('aria-expanded', 'false'); search?.removeAttribute('aria-activedescendant');
      };
      const open = () => {
        closeCustoms(); closeCity();
        popup.hidden = false; trigger.setAttribute('aria-expanded', 'true'); search?.setAttribute('aria-expanded', 'true');
        if (search) search.value = '';
        placeDropdown(trigger, popup, list, searchable);
        render();
        if (search) search.focus();
      };
      const choose = (option) => {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        updateValue(); close(); trigger.focus();
      };
      const keyboard = (event) => {
        if (event.key === 'Tab') { close(); return; }
        if (event.key === 'Escape') { event.preventDefault(); close(); trigger.focus(); return; }
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault(); const wasClosed = popup.hidden;
          if (wasClosed) open();
          if (!filtered.length) return;
          if (event.key === 'Home') highlight(0);
          else if (event.key === 'End') highlight(filtered.length - 1);
          else if (!wasClosed) highlight((active + (event.key === 'ArrowDown' ? 1 : -1) + filtered.length) % filtered.length);
          else if (event.key === 'ArrowUp' && !select.value) highlight(filtered.length - 1);
        } else if (event.key === 'Enter' || (event.key === ' ' && event.target !== search)) {
          event.preventDefault();
          if (popup.hidden) open(); else if (filtered[active]) choose(filtered[active]);
        } else if (!search && event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
          event.preventDefault();
          const now = performance.now(); typeBuffer = now - typedAt > 700 ? event.key : typeBuffer + event.key; typedAt = now;
          if (popup.hidden) open();
          const match = filtered.findIndex((option) => normalize(option.textContent).startsWith(normalize(typeBuffer)));
          if (match >= 0) highlight(match);
        }
      };
      trigger.addEventListener('click', () => popup.hidden ? open() : close());
      trigger.addEventListener('keydown', keyboard);
      search?.addEventListener('input', render); search?.addEventListener('keydown', keyboard);
      wrap.addEventListener('focusout', (event) => { if (!wrap.contains(event.relatedTarget)) close(); });
      document.addEventListener('pointerdown', (event) => { if (!wrap.contains(event.target)) close(); });
      select.addEventListener('change', updateValue);
      select.addEventListener('invalid', (event) => {
        event.preventDefault();
        error.textContent = select.options[0]?.textContent || select.validationMessage; error.hidden = false;
        trigger.setAttribute('aria-invalid', 'true'); trigger.setAttribute('aria-describedby', error.id);
        if (form.querySelector('select:invalid') === select) trigger.focus();
      });
      updateValue();
      const entry = { close, sync: updateValue }; customSelects.push(entry); return entry;
    };
    countryControl = makeCustomSelect(country, true);
    [form.querySelector('[data-roadmap-stage]'), form.querySelector('[data-roadmap-focus]'), form.querySelector('[data-roadmap-area]'), form.querySelector('[data-roadmap-budget]'), form.querySelector('[data-roadmap-timing]')].forEach((select) => makeCustomSelect(select));
    const setStep = (next, focus) => {
      current = next;
      close(); closeCustoms();
      steps.forEach((step) => { const activeStep = Number(step.dataset.roadmapStep) === current; step.hidden = !activeStep; Array.from(step.elements).forEach((el) => { el.disabled = !activeStep; }); });
      if (progress) { progress.textContent = `${current} / ${steps.length}`; progress.hidden = current === 1; }
      if (focus) steps.find((step) => Number(step.dataset.roadmapStep) === current)?.querySelector('legend')?.focus();
    };
    const validateStep = () => {
      if (current === 2) syncPhone();
      if (current === 3 && !city.value) {
        trigger.setAttribute('aria-invalid', 'true');
        open();
        search.setCustomValidity(picker.dataset.error);
        search.reportValidity();
        search.setCustomValidity('');
        return false;
      }
      const invalid = steps[current - 1].querySelector(':invalid');
      if (invalid) { invalid.reportValidity(); return false; }
      return true;
    };
    const advance = () => { if (!validateStep()) return; if (fullName) fullName.value = [first.value.trim(), last.value.trim()].filter(Boolean).join(' '); setStep(Math.min(steps.length, current + 1), true); };
    form.classList.add('is-enhanced');
    form.querySelectorAll('[data-roadmap-next]').forEach((button) => button.addEventListener('click', advance));
    form.querySelectorAll('[data-roadmap-back]').forEach((button) => button.addEventListener('click', () => setStep(Math.max(1, current - 1), true)));
    [first, last, national, otherCity].forEach((input) => input?.addEventListener('keydown', (event) => { if (event.key === 'Enter') { event.preventDefault(); advance(); } }));
    form.addEventListener('submit', (event) => {
      if (current < steps.length) { event.preventDefault(); advance(); return; }
      if (!validateStep()) { event.preventDefault(); return; }
      if (fullName) fullName.value = [first.value.trim(), last.value.trim()].filter(Boolean).join(' ');
      syncPhone();
      const answers = {};
      [city, ...form.querySelectorAll('[data-roadmap-stage],[data-roadmap-focus],[data-roadmap-area],[data-roadmap-budget],[data-roadmap-timing]')].forEach((input) => {
        const label = input.closest('label')?.firstChild.textContent.trim() || picker.querySelector('label').textContent.trim();
        answers[label] = input === city && city.value === 'other' ? otherCity.value.trim() : input.selectedOptions[0].textContent.trim();
      });
      try { sessionStorage.setItem(storageKey, JSON.stringify({ at: Date.now(), stage: form.querySelector('[data-roadmap-stage]').value, answers })); } catch (_) { }
      steps.forEach((step) => Array.from(step.elements).forEach((element) => { element.disabled = false; }));
    });
    syncOtherCity();
    syncCountryFace();
    setStep(1, false);
  });
})();
